import { useNavigate } from '@tanstack/react-router'

import {
  IconGtoWizardLogoSigned,
  IconRakebackWizardLogoSigned,
  IconTableWizardLogoSigned,
} from '@gto/ui/assets'
import { cn } from '@gto/ui/cn'
import { LogoSelector } from '@gto/ui/components/logo-selector'
import { useMediaQuery } from '@gto/ui/hooks/use-media-query'
import { gtoWizardAppUrl, tableWizardUrl } from '@gto/urls'

import { zIndex } from '@/utils/constants'

export const HeaderAppSelector = () => {
  const navigate = useNavigate()

  const isSmAndLower = useMediaQuery('down', 800)

  return (
    <div
      className={cn(
        'flex-[0_0_auto]',
        '[&_button]:border-none [&_button]:bg-transparent [&_button]:shadow-none',
        '[&_.MuiIcon-root]:size-8',
        '[&_.MuiIcon-root_svg]:transition-colors [&_.MuiIcon-root_svg]:duration-300',
        '[&_.MuiIcon-root:hover_svg]:text-primary-main',
        '[&_.MuiStack-root]:gap-0 [&_.MuiStack-root]:p-0',
      )}
    >
      <LogoSelector
        // Lift above rbwizard's high-z navbar (zIndex.header) so the
        // portaled dropdown isn't hidden behind it.
        positionerStyle={{ zIndex: zIndex.header + 1 }}
        button={{
          label: 'Rakeback Wizard',
          logo: <IconRakebackWizardLogoSigned width={isSmAndLower ? 120 : 'inherit'} />,
          onClick: () => {
            navigate({
              to: '/',
            }).catch(console.error)
          },
        }}
        items={[
          {
            logo: <IconGtoWizardLogoSigned />,
            link: gtoWizardAppUrl,
            label: 'GTO Wizard',
          },
          {
            logo: <IconTableWizardLogoSigned />,
            link: tableWizardUrl,
            label: 'Table Wizard',
          },
        ]}
      />
    </div>
  )
}
